export default __webpack_public_path__ + "static/media/cirun-logo-inverted.feaff15c.svg";